export const DECISION_REJECTED = "rejected";
export const DECISION_APPROVED = "approved";
export const DECISION_PENDING = "pending";
export const DECISION_ERROR = "error";
export const DECISION_AWAITING_USER_RESPONSE = "awaiting_user_response";